import React from "react"

const Ping = () => {
  return (
    <>/ping</>
  )
}

export default Ping